import React from "react";

interface ProfitBarProps {
  totalRecovered: number;
  lastChange: number;
}

const ProfitBar: React.FC<ProfitBarProps> = ({ totalRecovered, lastChange }) => {
  return (
    <div className="fixed top-0 left-0 right-0 bg-[#1a1a1a] border-b border-[#333] px-4 py-2 flex justify-between items-center z-50">
      <div className="text-[#666] text-xs uppercase">Doliczone pozycje</div>
      <div className="flex items-center gap-3">
        {lastChange > 0 && (
          <span className="text-[#00e676] text-xs">+{lastChange.toFixed(0)} zł</span>
        )}
        <span className="text-white font-bold">{totalRecovered.toFixed(0)} zł</span>
      </div>
    </div>
  );
};

export default ProfitBar;
